<div
	class="bg-orange-lighter border border-grey-veryLight p-3 rounded"
	*ngIf="(messages$ | async)?.length > 0"
>
	<div #message class="transition-all overflow-hidden" [style.height]="height">
		<div *ngFor="let message of messages$ | async" class="text-grey">
			<p [innerHtml]="message"></p>
		</div>
	</div>
	<div *ngIf="!showAll" class="flex justify-center mt-3" [@openClose]>
		<app-button
			(click)="clickShowAll()"
			btn="tertiary"
			size="small"
			[testHook]="testHooks.ReadMoreButton"
			>Read more</app-button
		>
	</div>
</div>
